import { Button, Typography, Box } from "@mui/material";

import { useForm, FormProvider } from "react-hook-form";

import DoYouMostlyDrinkAtHomeStepRadioButtons from "./RadioButtons/DoYouMostlyDrinkAtHomeStepRadioButtons";
import { useState } from "react";

const drinkWhere = [
  { id: "1", label: "Mostly at home", value: "home" },
  {
    id: "2",
    label: "Mostly out and about",
    value: "out",
  },
];

type FormValues = {
  homeOrOut: string;
};

const DoYouMostlyDrinkAtHomeStep = ({
  updateStep,
  previousStep,
  formData,
  setFormData,
  step,
}: any) => {
  const methods = useForm<FormValues>({
    defaultValues: { homeOrOut: formData.homeOrOutStep.homeOrOut },
    // mode: "onChange",
  });

  const [clickButton, setClickButton] = useState(false);

  const { handleSubmit } = methods;

  const formSubmit = (data: any) => {
    setFormData({
      ...formData,
      homeOrOutStep: data.target.defaultValue,
    });
    setClickButton(true);
    setTimeout(() => {
      updateStep();
    }, 500);
  };

  return (
    <>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(formSubmit)}>
          <Box
            sx={{
              height: { xs: "400px", lg: "502px" },
              width: { xs: "100%", sm: "100%", lg: "100%" },
              border: "2px solid #FFF",
              borderTopRightRadius: { xs: 0, lg: "18px" },
              borderBottomRightRadius: { xs: "18px", lg: "18px" },
              borderBottomLeftRadius: { xs: 18, lg: "0" },
              display: "flex",
              background: "#F2F2F2",
              alignItems: "center",
              flexDirection: "column",
              justifyContent: "flex-start",
            }}
          >
            <Box
              sx={{
                width: "100%",
                padding: {
                  xs: "0 0 4% 0",
                  sm: "0 0 10px 0",
                  lg: "25px 0 0 0 ",
                },
                margin: {
                  xs: "10px 0 0 0",
                  sm: "100px 0 0 0",
                  lg: "0% 0 0 0",
                },
                display: { xs: "none", lg: "flex" },
                justifyContent: { xs: "space-between", lg: "flex-start" },
              }}
            >
              <Button
                onClick={previousStep}
                sx={{
                  height: "2.7rem",
                  borderRadius: "50px",
                  width: { xs: "50%", lg: "7rem" },
                  color: "#FF3A18",

                  ":hover": {
                    backgroundColor: "transparent",
                  },
                }}
                type="submit"
                variant="text"
              >
                <Typography
                  sx={{
                    fontFamily: "Manrope",
                    textTransform: "capitalize",
                    fontWeight: "600",
                    fontSize: "18px",
                  }}
                >
                  Back
                </Typography>
              </Button>
            </Box>

            <Box
              className="transitions"
              style={{
                position: "relative",
                display: "flex",
                alignSelf: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <DoYouMostlyDrinkAtHomeStepRadioButtons
                name="homeOrOut"
                options={drinkWhere}
                step={step}
                onClickButton={formSubmit}
              />

              <Box
                sx={{
                  display: { xs: "flex", lg: "none" },

                  width: "100%",
                  position: "absolute",
                  bottom: "25px",
                }}
              >
                <Button
                  onClick={previousStep}
                  sx={{
                    height: "2.7rem",
                    borderRadius: "50px",
                    width: { xs: "0%", lg: "7rem" },
                    color: "#FF3A18",

                    ":hover": {
                      backgroundColor: "transparent",
                    },
                  }}
                  type="submit"
                  variant="text"
                >
                  <Typography
                    sx={{
                      fontFamily: "Manrope",
                      textTransform: "capitalize",
                      fontWeight: "600",
                      fontSize: "18px",
                    }}
                  >
                    Back
                  </Typography>
                </Button>
              </Box>
            </Box>
          </Box>
        </form>
      </FormProvider>
    </>
  );
};

export default DoYouMostlyDrinkAtHomeStep;
